import { useEffect, useCallback } from 'react';
import { withJsonFormsControlProps, useJsonForms } from '@jsonforms/react';
import { updateErrors } from '@jsonforms/core';
import type { ControlProps } from '@jsonforms/core';

import { AdditionalVocabEditor } from '../../CustomComponents/AdditionalVocabEditor';

const AdditionalVocabControl = ({
  data,
  handleChange,
  path,
  label,
  required,
  schema,
}: ControlProps) => {
  const { dispatch } = useJsonForms();

  const sendError = useCallback(
    (errorMessage: string | null) => {
      dispatch?.(
        updateErrors(
          errorMessage
            ? [
                {
                  message: errorMessage,
                  instancePath: path.startsWith('/') ? path : `/${path}`,
                  keyword: 'custom',
                  schemaPath: '',
                  params: {},
                },
              ]
            : []
        )
      );
    },
    [dispatch, path]
  );

  useEffect(() => {
    sendError(null);
  }, [sendError]);

  return (
    <AdditionalVocabEditor
      value={data}
      label={label}
      required={required}
      helperText={
        (schema as any)?.helperText ??
        'Must be a valid JSON array of objects with `content` and `sounds_like` fields'
      }
      onChange={(newValue, error) => {
        handleChange(path, newValue);
        sendError(error);
      }}
    />
  );
};

export default withJsonFormsControlProps(AdditionalVocabControl);
